import React, { useState, useEffect } from 'react';
import '../style/Accueil.css';

const Accueil = () => {
  const [displayText, setDisplayText] = useState('');
  const [index, setIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const fullText = "Location d'engins de travaux publics et construction au Cameroun";

  useEffect(() => {
    if (index < fullText.length) {
      const timer = setTimeout(() => {
        setDisplayText(fullText.substring(0, index + 1));
        setIndex(index + 1);
      }, 50);
      return () => clearTimeout(timer);
    } else if (index === fullText.length && !isTypingComplete) {
      setIsTypingComplete(true);
    }
  }, [index, fullText, isTypingComplete]);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="accueil" className="hero">
      <div className="hero-overlay"></div>
      <div className="hero-container">
        <div className={`hero-content ${isVisible ? 'fade-in-up' : 'opacity-0'}`}>
          <h1 className="hero-title">
            BEVERLY HILLS <span className="hero-title-orange">CONSTRUCTION</span>
          </h1>
          <p className="hero-subtitle typing-subtitle">
            {displayText}{!isTypingComplete && <span className="cursor">|</span>}
          </p>
          <p className="hero-description">
            Basé à Denver, à Douala Cameroun, nous intervenons sur tout le territoire avec des engins fiables et des professionnels qualifiés
          </p>
          <div className="hero-buttons">
            <a href="#engins" className="btn btn-primary">
              Voir nos engins
            </a>
            <a href="#contact" className="btn btn-secondary">
              Demander un devis
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Accueil;